/* tslint:disable */
/* eslint-disable */
export enum PaymentType {
  Unpaid = 'UNPAID',
  Full = 'FULL',
  Partial = 'PARTIAL',
}
